import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import { PlcHeating } from "./types";

import Source from "./components/Source";
import SourceMetric from "./components/SourceMetric";


interface IProps {
  data: PlcHeating;
}


const SourceHeating: FunctionComponent<IProps> = memo(function SourceHeating({
  data,
}) {
  const intl = useIntl();

  return <>
    <Source
      name={intl.formatMessage({
        id: "site__control__heating__name",
        defaultMessage: "Heating",
      })}
      offline={!data}
      {...data}
    >
      {data && <>
      <SourceMetric
        secondary
        name={intl.formatMessage({
          id: "site__control__heating__output",
          defaultMessage: "Output",
        })}
        value={data.power}
        unit="%"
      />
      <SourceMetric
        name={intl.formatMessage({
          id: "site__control__heating__temperature",
          defaultMessage: "Temperature",
        })}
        value={data.metrics?.c_temperature}
        unit="°C"
      />
      </>}
    </Source>
  </>
}, isEqual);

export default SourceHeating;
